module.exports = __webpack_public_path__ + "img/Vector_7.285e1f59.svg";